export class CarveOut{
    id:string = '';
    contractId:string ='';
    code:string ='00000';
    description:string='';
    rate:number=0;
    applyMultiProcedureDisc:boolean=false;
    isCaseRate:boolean=false;
}